module.exports = require("@jswork/next-is-empty");